import { ColDef } from 'ag-grid-community';
import { EmailCellComponent } from '../../../../../layouts/my-projects/new-project/project-permissions/table/renderer/email/email-cell.component';
import { ActionCellComponent } from './renderer/action/action-cell.component';
import { DecisionMakerCellComponent } from './renderer/decision-maker/decision-maker-cell.component';
import { UserCellComponent } from './renderer/user/user-cell.component';
import { TransferWorkspaceProjectsRightsCellComponent } from './renderer/transfer/transfer-project-rights-cell.component';

import { WORKSPACE_PROJECT_COLUMNS } from '../constants/workspace-projects.constants';

export const workspaceProjectParticipantColumnsDef: ColDef[] = [
  {
    field: WORKSPACE_PROJECT_COLUMNS.ACTION.FIELD,
    headerName: WORKSPACE_PROJECT_COLUMNS.ACTION.HEADER,
    minWidth: WORKSPACE_PROJECT_COLUMNS.ACTION.MIN_WIDTH,
    flex: WORKSPACE_PROJECT_COLUMNS.ACTION.FLEX,
    sortable: false,
    cellRenderer: ActionCellComponent,
  },
  {
    field: WORKSPACE_PROJECT_COLUMNS.USER.FIELD,
    headerName: WORKSPACE_PROJECT_COLUMNS.USER.HEADER,
    minWidth: WORKSPACE_PROJECT_COLUMNS.USER.MIN_WIDTH,
    flex: WORKSPACE_PROJECT_COLUMNS.USER.FLEX,
    sortable: true,
    cellRenderer: UserCellComponent,
  },
  {
    field: WORKSPACE_PROJECT_COLUMNS.EMAIL.FIELD,
    headerName: WORKSPACE_PROJECT_COLUMNS.EMAIL.HEADER,
    minWidth: WORKSPACE_PROJECT_COLUMNS.EMAIL.MIN_WIDTH,
    flex: WORKSPACE_PROJECT_COLUMNS.EMAIL.FLEX,
    sortable: true,
    autoHeight: true,
    cellRenderer: EmailCellComponent,
  },
  {
    field: WORKSPACE_PROJECT_COLUMNS.OWNERSHIP.FIELD,
    headerName: WORKSPACE_PROJECT_COLUMNS.OWNERSHIP.HEADER,
    minWidth: WORKSPACE_PROJECT_COLUMNS.OWNERSHIP.MIN_WIDTH,
    flex: WORKSPACE_PROJECT_COLUMNS.OWNERSHIP.FLEX,
    sortable: false,
    autoHeight: true,
    cellRenderer: TransferWorkspaceProjectsRightsCellComponent,
  },
  {
    field: WORKSPACE_PROJECT_COLUMNS.DECISION_MAKER.FIELD,
    headerName: WORKSPACE_PROJECT_COLUMNS.DECISION_MAKER.HEADER,
    minWidth: WORKSPACE_PROJECT_COLUMNS.DECISION_MAKER.MIN_WIDTH,
    flex: WORKSPACE_PROJECT_COLUMNS.DECISION_MAKER.FLEX,
    sortable: false,
    autoHeight: true,
    suppressHeaderMenuButton: true,
    suppressHeaderContextMenu: true,
    cellRenderer: DecisionMakerCellComponent,
  },
];
